<template>
  <div class="register auth auth--register">
    <div class="auth__column auth__column--primary">
      <div class="auth__content auth__content--register">
        <div class="register__branding">
          <div v-if="site.id == 'BRI'">
            <logo
              :class="`logo--${site.id}`"
              logo="https://shineraychile.cl/content/uploads/2023/09/logo-shineray-negro.png"
            ></logo>
          </div>
          <div v-else>
            <logo
              :class="`logo--${site.id}`"
              :logo="current_brand && current_brand.logo"
            ></logo>
          </div>
        </div>

        <div class="register__form mt-5 mb-3 mx-auto">
          <h1 class="title title--l text-primary text-center weight-bolder">
            Registro agendamiento
          </h1>
          <register-form title="Registro agendamiento"></register-form>
        </div>

        <a
          v-if="site.label"
          :href="site.url"
          class="auth__external site-external"
          target="_blank"
          rel="noopener"
          >{{ site.label }} <i class="material-icons">exit_to_app</i></a
        >
      </div>
      <div class="auth__footer">
        <router-link class="button button--back" to="/ingresar">
          <i class="button__icon material-icons">arrow_back</i>
          <span class="button__text">Volver al Ingreso</span>
        </router-link>
      </div>
    </div>
    <div class="auth__column auth__column--secondary">
      <div
        class="auth__background background"
        :style="
          `background-image: url(${current_brand && current_brand.background});`
        "
      ></div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo';
import RegisterForm from '@/components/RegisterForm';

import { mapState } from 'vuex';

export default {
  name: 'Register',
  components: {
    Logo,
    RegisterForm,
  },
  data() {
    return {
      site: {
        id: process.env.VUE_APP_BRAND_ID || '',
        label: process.env.VUE_APP_BRAND_SITE_LABEL || '',
        url: process.env.VUE_APP_BRAND_SITE_URL || '',
      },
    };
  },
  computed: {
    ...mapState(['current_brand']),
  },
};
</script>
